import React from 'react';
import { Card, CardHeader, CardBody, CardFooter, Col, Button } from "reactstrap";


export default function CardIntegracao({ integracao, handleClickIntegacao }) {
    return (
      <>
        <Col lg="4" md="6" sm="6" className="d-flex">
          <Card className="card-stats card-box flex-fill">
            <CardHeader className="titulo-card mx-3" style={{fontSize: "1.3em", opacity: "0.8"}}>
              {integracao == "RCC" ? <i class="fas fa-city mr-5"></i> : integracao == "RSS" ? <i class="fas fa-plus-circle mr-5"></i> : <i class="fas fa-trash-alt mr-5"></i>}
              {integracao == "RCC" ? "Cadastro de RCC" : integracao == "RGG" ? "Cadastro de RGG" : "Cadastro de RSS"}
            </CardHeader>
            <hr className='mb-0'/>
            <CardBody className="text-center">
              <span className="display-5">{integracao == "RCC" ? "Cadastramento de geradores, transportadoras e  destinos final da construção civil" : integracao == "RGG" ? "Cadastramento de Grandes Geradores, transportadoras e  destinatário da coleta privada" : "Cadastramento de geradores de resíduos de saúde"}</span>
            </CardBody>
            <CardFooter className="text-center mt-2">
              <Button color="success" onClick={() => handleClickIntegacao()}>Cadastrar</Button>
            </CardFooter>
          </Card>
        </Col>
      </>
    );
  }